"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.returnNullIfEmpty = exports.reorderArray = exports.removeDuplicateObjects = exports.defineLinearGradientFromArrayOfGroups = exports.arrayGetDistinctValues = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var arrayGetDistinctValues = exports.arrayGetDistinctValues = function arrayGetDistinctValues(arr) {
  return arr && (0, _toConsumableArray2["default"])(new Set(arr));
};
var removeDuplicateObjects = exports.removeDuplicateObjects = function removeDuplicateObjects(arr) {
  return arr && arr.map(function (y) {
    return JSON.stringify(y);
  }).filter(function (x, i, arr) {
    return arr.indexOf(x) === i;
  }).map(function (o) {
    return JSON.parse(o);
  });
};
var returnNullIfEmpty = exports.returnNullIfEmpty = function returnNullIfEmpty(arr) {
  if (Array.isArray(arr) && arr.length > 0) {
    return arr;
  }
  return null;
};
var reorderArray = exports.reorderArray = function reorderArray(arr, fromIndex, toIndex) {
  if (!arr || !arr.length) {
    return arr;
  }
  var newArr = (0, _toConsumableArray2["default"])(arr);
  var element = arr[fromIndex];
  newArr.splice(fromIndex, 1);
  newArr.splice(toIndex, 0, element);
  return newArr;
};
var defineLinearGradientFromArrayOfGroups = exports.defineLinearGradientFromArrayOfGroups = function defineLinearGradientFromArrayOfGroups(groups) {
  if (!groups || !groups.length) {
    return "#ffffff";
  }
  if (groups && groups.length === 1) {
    return "#".concat(groups[0].color);
  }
  var delimetar = 100 / groups.length;
  var css = 'linear-gradient(';
  var _iterator = _createForOfIteratorHelper(groups.entries()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = (0, _slicedToArray2["default"])(_step.value, 2),
        i = _step$value[0],
        g = _step$value[1];
      if (i === 0 || groups.length === i + 1) {
        css += "#".concat(g.color, " ").concat(delimetar, "%");
      }
      if (i !== 0 && groups.length !== i + 1) {
        css += "#".concat(g.color, " ").concat(delimetar, "% ").concat(delimetar + delimetar, "%");
      }
      if (groups.length !== i + 1) {
        css += ', ';
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  css += ')';
  return css;
};